/**
 * @author Jersson Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart stock',
  'sidebar.usuario': 'User',
  'sidebar.persona': 'Person',
  'usuario.agregarUsuario': 'Create User',
  'usuario.modificarUsuario': 'Edit User',
  'usuario.eliminarUsuario': 'Delete User',
  'usuario.idUsuario': 'User Id',
  'usuario.idPersona': ' Person Id',
  'usuario.login': ' Username',
  'usuario.nombrePersona': 'Person Name',
  'usuario.correoElectronico': ' Email',
  'usuario.clave': ' Password',
  'usuario.confirmacionClave': 'Confirm password',
  'usuario.encriptacionAleatoria': ' Random Encryption',
  'usuario.tipoUsuario': ' User Type',
  'usuario.observaciones': ' Observations',
  'usuario.foto': ' Photo',
  'usuario.estado': ' Status',
  'usuario.usuario': 'User',
  'usuario.agencia.idAgencia': 'Agency',
  'usuario.agencia.idPerfil': 'Profile',
  'usuario.agencia.agenciaPorDefecto': 'Default agency',
  'usuario.verUsuario': 'View User',
  'usuario.cambiarClave': 'Change Password',
  'usuario.alerta.agenciaPerfilRepetido': 'The user already has the profile in the selected agency.',
  'usuario.alerta.agenciaPorDefectoExistente': 'The user already has an agency by default.',
  'usuario.alerta.usuarioSinAgencia': 'You must associate at least one agency with a profile.',
  'usuario.alerta.usuarioSinAgenciaPorDefecto': 'You must mark an agency as the default agency.',
  'usuario.alerta.clavesDiferentes': 'Passwords do not match.',
  'usuario.alerta.ContrasenaNoValida':
    'Invalid password. It must contain more than 8 characters, between uppercase, lowercase, numbers and special characters.',
  'usuarioPersona.cancelar': 'The unsaved data will be lost, do you want to close the window?',
};
